import { render, staticRenderFns } from "./commonTasksDetail.vue?vue&type=template&id=834f9c66&"
import script from "./commonTasksDetail.vue?vue&type=script&lang=tsx&"
export * from "./commonTasksDetail.vue?vue&type=script&lang=tsx&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports